import every from '@Ravnur-Inc/nanoutils/every';

import identity from '@Ravnur-Inc/nanoutils/identity';
import not from '@Ravnur-Inc/nanoutils/not';

import isAndroid from './isAndroid';
import isiOS from './isiOS';

export default every(not(identity), [isAndroid, isiOS]);
